import { render } from "./HomeHowItWorks.vue?vue&type=template&id=0bfc13d6"
import script from "./HomeHowItWorks.vue?vue&type=script&lang=js"
export * from "./HomeHowItWorks.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__